import { faTimesCircle, faXmark } from "@fortawesome/free-solid-svg-icons";
import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { handleError } from "../../utils/Utils";
import { URL } from "../../utils/Constants";
import "../../assets/scss/flashCard.scss";
import { Upload } from "../../assets/icons/icon";

const CardTemplate = ({
  id,
  question,
  answer,
  hint,
  index,
  imagePreview,
  imageName,
  removeImage,
  removeFlashCard,
  handleImageChange,
  handleFlashCardChange,
  handleDeleteFlashCard,
}) => {
  const fileRef = useRef(null);

  return (
    <div className="flash-card-container">
      <div className="flash-card-content">
        <div className="heading">
          <h4>Flash Card</h4>
          <FontAwesomeIcon
            icon={faXmark}
            fontSize={14}
            onClick={(e) =>
              id ? handleDeleteFlashCard(id, index) : removeFlashCard(e, index)
            }
          />
        </div>
        <input
          name="image"
          id={"fileImage" + index}
          type="file"
          ref={fileRef}
          onChange={(e) => handleImageChange(e, index)}
          accept="image/png, image/jpeg,image/gif,image/jpg,image/PNG,image/JPEG,image/JPG,image/GIF"
          hidden
        />

        {imagePreview || imageName ? (
          <div className="image-container imageHover">
            <img
              src={imageName ? URL.imageSelectURL + imageName : imagePreview}
              alt="flash card"
              onError={(e) => handleError(e)}
            />
            <div className="button-container">
              <button
                onClick={() => fileRef?.current?.click()}
                className="grayOutline-btn"
              >
                Change Image
              </button>
            </div>
          </div>
        ) : (
          <div
            onClick={() => fileRef?.current?.click()}
            className="image-container"
          >
            <Upload />
            <span>Upload Image</span>
          </div>
        )}
        {/* <div
        style={{ position: "relative" }}
        className="mt-2 tt-flashCard-img-box text-center"
      >
        {imagePreview || imageName ? (
          <>
            <img
              src={imageName ? URL.imageSelectURL + imageName : imagePreview}
              alt="flash card"
              onError={(e) => handleError(e)}
              className="tt-img"
            ></img>
            <FontAwesomeIcon
              icon={faTimesCircle}
              style={{ top: 0, right: 0 }}
              className="tt-imgDeleteFlashCard"
              onClick={(e) => removeImage(e, index)}
            ></FontAwesomeIcon>
          </>
        ) : (
          <>
            <div className="row h-100 justify-content-center align-items-center">
              <div className="col-12">
                <input
                  name="image"
                  id={"fileImage" + index}
                  type="file"
                  ref={fileRef}
                  onChange={(e) => handleImageChange(e, index)}
                  style={{ display: "none" }}
                  // accept="image/x-png,image/gif,image/jpeg"
                  accept="image/png, image/jpeg,image/gif,image/jpg,image/PNG,image/JPEG,image/JPG,image/GIF"
                />
                <button
                  className="tt-button tt-button-primary"
                  onClick={() => {
                    fileRef.current.click();
                  }}
                >
                  Attach File
                </button>
              </div>
            </div>
          </>
        )}
      </div> */}
        <div className="textarea-container">
          <textarea
            name="question"
            className="form-control"
            value={question}
            placeholder="Enter Front text"
            onChange={(e) => handleFlashCardChange(e, index)}
          />
          <textarea
            name="answer"
            className="form-control"
            value={answer}
            placeholder="Enter Back text"
            onChange={(e) => handleFlashCardChange(e, index)}
          />
          <textarea
            name="hint"
            className="form-control"
            value={hint}
            onChange={(e) => handleFlashCardChange(e, index)}
            placeholder="Enter Hint"
          />
        </div>
      </div>
    </div>
  );
};

export default CardTemplate;
